import type { QueryClient } from '@tanstack/react-query';
import { customerQueryKeys } from './queryKeys.js';

/** Drop tenant account caches so a new customerId never reads the previous user's rows. */
export function clearCustomerAccountCache(
  queryClient: QueryClient,
  tenantCode: string
): void {
  queryClient.removeQueries({
    queryKey: customerQueryKeys.accountPrefix(tenantCode),
  });
}
